// extracted by mini-css-extract-plugin
export var dark = "iframe-module--dark--bdf02";
export var grid = "iframe-module--grid--f8f1e";
export var iframe = "iframe-module--iframe--eaba5";
export var iframeModule = "iframe-module--iframeModule--e2647";
export var light = "iframe-module--light--0c553";
export var medium = "iframe-module--medium--069f9";
export var short = "iframe-module--short--020c2";
export var tall = "iframe-module--tall--2ea41";